import React from "react";
import { useState,useEffect } from "react";
import { configData } from "../config";
import { Link, useNavigate,useLocation,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from './Loading';

import ScoutSidebar from './ScoutSidebar';

/* const agentAccount = {
    smwwMail:"",
    name:"TestKrishna Roja",
    personalMail:"Krishnaroja@gmail.com",
    publicProfile: "https://www.smwwagency.com/agent/testkrishna-rojatest",
} */

const ScoutHome = ({userLoggedInRoles, uid}) => {

    const [isLoading, setIsLoading] = useState(true); 
   
    const [showcontent,setShowContent] = useState(true);
    const location  = useLocation();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    // var {uid} = useParams();
    // if(location.state) {
    //     uid = location.state;
    // }

    useEffect(() => {
                  Promise.all([
                      checkpermissionforpageaccess()
                  ])
                  .then(() => {
               
                  setIsLoading(false);
                  })
               
              },[]);
               async function checkpermissionforpageaccess() {
        
           
                const response = await fetch(
                     app_url+'smwwscout/checkpermissionforpageaccess?uid='+loggedin_uid,
                    {
                        method: "GET",
      
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )           
                const responsedata = await response.json();
                if(responsedata.data.msg === "Success") {
                    setShowContent(true);
                } 
                 if(responsedata.data.msg === "Error") {
                   setShowContent(false);
                } 
    
           
        }
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div>
                        {(userLoggedInRoles.includes(configData.ROLE_AGENT) && 
                        !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) 
                        || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && ( 
                            <div style={{fontWeight: "bold", background: "bisque", padding: "10px", marginBottom: "10px"}}>
                                Trying to access your SMWW Agency account? 
                                <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/user/"+uid} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
                            </div>
                        )} 
                    {showcontent ? (
                        <>
                    <h1>Welcome to the SMWWScout.com!</h1>
                            <br/>
    As an SMWW Scout you can <a href={"/user/"+uid+"/edit_scout"}>upload or change your website bio</a>, 
    upload or change your website headshot, 
    and <a href="/node/add/scout-report">upload your personal scouting reports</a> that you want to display 
    to the public. In addition you can <a href="/admin/reports/scouting_request">view the list of scouting requests</a>.<br/><br/>  
	If you agree to send a scouting report, you must send it within 5 to 7 business days to the requester's email and accept to incur any expenses at your own risk.<br/><br/> 
    Anytime you contact someone on the Scouting Request list, you assume responsibility of representing 
    SMWW and yourself in the most professional manner. We recommend you call and introduce yourself as an SMWW Scout, and offer your scouting services.
    <p style={{ fontStyle: 'italic', margin: '14px 0px' }}>
      Remember you represent Sports Management Worldwide and our motto is to treat all people ethically 
      and with integrity. We want to provide a foundation that assists you in growing your sports career!
    </p>
    <p>Most importantly, have fun because it's all a learning experience!<br /><br/> 
    <strong>Dr. Lynn Lashbrook</strong></p> 

    </>
                    ) : (
                        <><div style={{ textAlign: 'center'}}><a id="Agent_Initiation" style={{ width:'60%' }} class="reddbtnn" href="/smww_misc_pay?lineitems=Scout_Initiation&country=">Subscribe to the SMWW Scout Program</a></div>
</>
                    )
                }
                </div>
            )}
        </>
    );
};
export default ScoutHome;